<div class="check-button" [ngClass]="{ 'check-button-checked': checked, reverse: reverse }">
  <div class="check-button-details">
    @if (title) {
      <h2 class="check-button-title" [ngClass]="{ 'small-font': smallFont }">{{ title }}</h2>
    }
    @if (info) {
      <div class="check-button-info">{{ info }}</div>
    }
  </div>
  <div class="check-button-icon">
    <i class="material-icons icon">check</i>
  </div>
</div>
